import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import StatsWidget from "@rio-cloud/rio-uikit/StatsWidget";
import StatsWidgetNumber from "@rio-cloud/rio-uikit/StatsWidgetNumber";
import StatsWidgetSpacer from "@rio-cloud/rio-uikit/StatsWidgetSpacer";
import { getUserProfile } from "../../configuration/login/loginSlice";

import { fetchAssetsByRioPlans } from "../../api/fetchBigNumbers";
import { IAssetSummary } from "../../api/fetchMaintenance";

import { Asset } from "../../models/asset";

const RioPlanBigNumbers = (
    {
        allAssets,
        assets,
        assetIds,
        setAssetIds,
        filter,
        setFilter,
        withRioPlanAssetIds,
        setWithRioPlanAssetIds,
        withoutRioPlanAssetIds,
        setWithoutRioPlanAssetIds,
        byRioPlan,
        setByRioPlan,
        disabled,
        bigTableLoading,
    }:
        {
            allAssets: Asset[],
            assets: IAssetSummary[],
            assetIds: string[],
            setAssetIds: (e: string[] | undefined) => void,
            filter: string,
            setFilter: (e: string) => void,
            withRioPlanAssetIds: string[],
            setWithRioPlanAssetIds: (e: string[]) => void,
            withoutRioPlanAssetIds: string[],
            setWithoutRioPlanAssetIds: (e: string[]) => void,
            byRioPlan: { [key: string]: string[] },
            setByRioPlan: (e: { [key: string]: string[] }) => void,
            disabled?: boolean,
            bigTableLoading?: boolean,
        }
) => {
    const [dataLoaded, setDataLoaded] = useState<boolean>(false);
    const [withRioPlanLoading, setWithRioPlanLoading] = useState<boolean>(true);
    const [withoutRioPlanLoading, setWithoutRioPlanLoading] = useState<boolean>(true);
    
    const [assetIdsWithoutFilter, setAssetIdsWithoutFilter] = useState<string[]>([]);
    const userProfile = useSelector(getUserProfile);
    // Inicializar assetIdsWithoutFilter quando assetIds muda
    useEffect(() => {
        if (assetIds.length > 0) {
            setAssetIdsWithoutFilter(assetIds);
        }
    }, [assetIds]);

    useEffect(() => {
        const fetchData = async () => {
            const fetchByRioPlanPromise = fetchAssetsByRioPlans(assets, userProfile || undefined);

            fetchByRioPlanPromise.then((byRioPlan) => {
                setWithRioPlanAssetIds(Object.values(byRioPlan).flat());
                setWithRioPlanLoading(false);

                setWithoutRioPlanAssetIds(assetIds.filter(id => !Object.values(byRioPlan).flat().includes(id)));
                setWithoutRioPlanLoading(false);

                setByRioPlan(byRioPlan);
            })

            setDataLoaded(true);
        }

        if (assetIds.length && !dataLoaded) fetchData();
        else if (!allAssets.length) {
            setDataLoaded(true);
            setWithRioPlanLoading(false);
            setWithoutRioPlanLoading(false);
        }

    }, [assetIds]);

    const getBigNumberValue = (bigNumberAssetIds: string[]): number => {
        // if (!disabled) return bigNumberAssetIds.length;
        const assetIdsSet = new Set(assetIds);
        const bigNumberAssetIdsSet = new Set(bigNumberAssetIds);
        return assetIdsSet.intersection(bigNumberAssetIdsSet).size;
    }

    const getAssetIds = (bigNumberAssetIds: string[]) => {
        return bigNumberAssetIds.filter((id: string) => assetIds.includes(id));
    }

    return (
        <StatsWidget className="card">
            <StatsWidget.Header>RIO</StatsWidget.Header>
            <StatsWidget.Body className="mt-4">
                <StatsWidgetNumber
                    className={`${withRioPlanLoading || bigTableLoading ? `animate-pulse` : ``} ${filter !== '' && filter !== 'withRioPlan' ? `` : 'cursor-pointer'}`}
                    value={withRioPlanLoading || bigTableLoading ?
                        <div className="width-30 height-40 bg-gray-300 rounded mb-8"></div> :
                        <span className={(filter !== '' && filter !== 'withRioPlan') || disabled ? `text-color-lighter` : 'text-color-status-driving'}>{getBigNumberValue(withRioPlanAssetIds)}</span>
                    }
                    label={withRioPlanLoading || bigTableLoading ?
                        <div className="width-70 h-8 bg-gray-300 rounded"></div> :
                        <span className={(filter !== '' && filter !== 'withRioPlan') || disabled ? `text-color-lighter` : ''}>Com RIO</span>
                    }
                    onClick={() => {
                        if ((filter !== 'withRioPlan' && filter !== '') || disabled) return;
                        if (filter !== 'withRioPlan') [setAssetIdsWithoutFilter(assets.map(asset => asset.id)), setFilter('withRioPlan'), setAssetIds(getAssetIds(withRioPlanAssetIds))];
                        else[setFilter(''), setAssetIds(assetIdsWithoutFilter)];
                    }}
                />
                <StatsWidgetSpacer />
                <StatsWidgetNumber
                    className={`${withoutRioPlanLoading || bigTableLoading ? `animate-pulse` : ``} ${filter !== '' && filter !== 'withoutRioPlan' ? `` : 'cursor-pointer'}`}
                    value={withoutRioPlanLoading || bigTableLoading ?
                        <div className="width-30 height-40 bg-gray-300 rounded mb-8"></div> :
                        <span className={(filter !== '' && filter !== 'withoutRioPlan') || disabled ? `text-color-lighter` : 'text-color-danger'}>{getBigNumberValue(withoutRioPlanAssetIds)}</span>
                    }
                    label={withoutRioPlanLoading || bigTableLoading ?
                        <div className="width-70 h-8 bg-gray-300 rounded"></div> :
                        <span className={(filter !== '' && filter !== 'withoutRioPlan') || disabled ? `text-color-lighter` : ''}>Sem RIO</span>
                    }
                    onClick={() => {
                        if ((filter !== 'withoutRioPlan' && filter !== '') || disabled) return;
                        if (filter !== 'withoutRioPlan') [setAssetIdsWithoutFilter(assets.map(asset => asset.id)), setFilter('withoutRioPlan'), setAssetIds(getAssetIds(withoutRioPlanAssetIds))];
                        else[setFilter(''), setAssetIds(assetIdsWithoutFilter)];
                    }}
                />
            </StatsWidget.Body>
        </StatsWidget>
    )
}

export default RioPlanBigNumbers;